/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResendTokenResponse {
    getFixupPrototypeFunction() { return ResendTokenResponse.fixupPrototype; }

    static newInstance(model: Partial<ResendTokenResponse>): ResendTokenResponse {
        let obj = Object.assign(new ResendTokenResponse(), model);
        ResendTokenResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResendTokenResponse>): ResendTokenResponse {
        if (!model) return null;
        return ResendTokenResponse.newInstance(<ResendTokenResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResendTokenResponse) {
        if (!obj) return;

        models.ResendTokenResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResendTokenResponse): boolean {
        Object.setPrototypeOf(obj, ResendTokenResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * user id
     */
    user_id: string;

}
